import { Alert, Space } from "antd"
import React, { memo, FC } from "react"
import { useMediaSize } from "../../layouts/Main/GetWindowDimensions/GetWindowDimensions"
import { renderCourseType } from "../../views/TableColumnRenderers/TableColumnRenderers"
import { GetCourseDetailsByIdPublicQuery } from "../../generated/graphql"
import { blue } from "@ant-design/colors"

type PreRequisiteCoursesType = GetCourseDetailsByIdPublicQuery["courseByIdPublic"]["bookingRestriction"]

type PreRequisiteCoursesProps = {
    bookingRestriction: PreRequisiteCoursesType
    mediaColumns?: number
    alertMessage?: string
    direction?: "horizontal" | "vertical"
}

const PreRequisiteCourses: FC<PreRequisiteCoursesProps> = ({
    bookingRestriction,
    mediaColumns = 1,
    alertMessage,
    direction = "vertical",
}) => {
    const mediaSize = useMediaSize()
    const prerequisiteCourses = bookingRestriction?.prerequisiteCourses || []
    const columnsRight = mediaColumns === 4 ? 2 : mediaColumns === 3 ? 2 : 1
    const columnsLeft = mediaColumns === 4 ? 2 : mediaColumns === 3 ? 1 : 1
    const message =
        alertMessage ??
        "Um diesen Kurs buchen zu können, muss der oder die Teilnehmerin mindestens in einen dieser Voraussetzungskurse eingebucht sein. Im nächsten Schritt kannst du sehen, ob die Voraussetzungskurse bereits gebucht wurden."
    const style =
        direction === "horizontal"
            ? {
                  display: "flex",
                  flexWrap: "wrap" as const,
                  justifyContent: "center",
                  width: "100%",
                  padding: "5px 5px 0 5px",
                  borderBottom: `2px solid ${blue[3]}`,
              }
            : {}

    return (
        <>
            {prerequisiteCourses.length > 0 ? (
                <>
                    <Alert
                        type='warning'
                        message={message}
                        style={{
                            width: "100%",
                            marginBottom: mediaSize.media === "xs" ? 15 : 0,
                            gridColumn: `span ${columnsLeft}`,
                            textAlign: direction === "horizontal" || mediaColumns === 1 ? "center" : "left",
                        }}
                    />
                    <Space
                        direction={mediaColumns > 1 ? direction : "vertical"}
                        size={1}
                        style={{ gridColumn: `span ${columnsRight}`, ...style }}
                    >
                        {prerequisiteCourses.map((prerequisiteCourse) => (
                            <div key={prerequisiteCourse.id}>
                                {renderCourseType({
                                    name: `${prerequisiteCourse?.courseType?.name} - ${prerequisiteCourse.prefixedCourseNumber}`,
                                    color: prerequisiteCourse?.courseType?.color,
                                    style: { textAlign: "center", whiteSpace: "nowrap", marginBottom: 4 },
                                })}
                            </div>
                        ))}
                    </Space>
                </>
            ) : null}
        </>
    )
}

export default memo(PreRequisiteCourses)
